import { render, staticRenderFns } from "./NejmCatalog.vue?vue&type=template&id=10f05c06&scoped=true"
import script from "./NejmCatalog.vue?vue&type=script&lang=js"
export * from "./NejmCatalog.vue?vue&type=script&lang=js"
import style0 from "./NejmCatalog.vue?vue&type=style&index=0&id=10f05c06&prod&lang=less&scoped=true"
import style1 from "./NejmCatalog.vue?vue&type=style&index=1&id=10f05c06&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f05c06",
  null
  
)

export default component.exports